<input type="file" #fileInputMulti multiple (change)="change($event)">
<input type="file" #fileInput (change)="change($event)">

<div [class.less-padding]="lessPadding" class="dropzone" (drop)="drop($event)" (dragover)="allowDrop($event)"  (click)="handleClick()">

    <div class="text">
        <div>
            <img src='../../assets/img/noe-free/icon-cargar-documentos.png' style="width: 50px; display: block; margin: 0 auto; margin-bottom: 10px;">
        </div>
        <span class="title-img">{{placeholder}}</span><br>
        <span class="title-formato">Tamaño: 300 x 200 px</span>
        <span class="title-formato">; </span>
        <span class="title-formato">Formatos soportados: jpg , png (2 MB).</span>
    </div>

</div>
